import { useState, useEffect } from "react";

function getState() {
  return document.body.classList.contains("cresc-has-bg");
}

export function useBg() {
  const [hasBg, setHasBg] = useState(getState);

  useEffect(() => {
    const on = () => {
      setHasBg(getState());
      // Re-run DOM override after React re-renders from this state change
      requestAnimationFrame(() => {
        if (typeof window._crescendoApplyDom === "function") {
          window._crescendoApplyDom(getState());
        }
      });
    };
    window.addEventListener("cresc-bg-changed", on);
    const obs = new MutationObserver(on);
    obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => { window.removeEventListener("cresc-bg-changed", on); obs.disconnect(); };
  }, []);

  if (!hasBg) {
    return {
      hasBg: false,
      sidebarStyle:    {},
      rightPanelStyle: {},
      mainPanelStyle:  {},
      topbarStyle:     {},
      appShellStyle:   {},
      panelGroupStyle: {},
      panelStyle:      {},
      structStyle:     {},
      transparentStyle:{},
    };
  }

  const blur = getComputedStyle(document.documentElement)
    .getPropertyValue("--cresc-bg-blur").trim() || "12px";

  // Sidebar: frosted glass — semi-transparent dark with blur
  const frosted = {
    background: "rgba(12,12,12,0.82)",
    backdropFilter: `blur(${blur}) saturate(1.3)`,
    WebkitBackdropFilter: `blur(${blur}) saturate(1.3)`,
  };

  // Structural bars (headers, capacity, etc): slightly transparent, NO blur
  // (avoiding nested backdrop-filter which can cause rendering issues)
  const struct = { background: "rgba(12,12,12,0.70)" };

  const transparent = { background: "transparent" };

  return {
    hasBg: true,
    sidebarStyle:    frosted,
    rightPanelStyle: frosted,
    mainPanelStyle:  transparent,
    topbarStyle:     { background: "rgba(12,12,12,0.72)" },
    appShellStyle:   transparent,
    panelGroupStyle: transparent,
    panelStyle:      transparent,
    structStyle:     struct,
    transparentStyle: transparent,
  };
}
